import React__default from 'react';
import { ThemeProvider as ThemeProvider$1 } from 'styled-components';
import { s as stormLightTheme } from '../LocalModules/storm-ui-tokens/dist/esm/index-CJg44kCr.js';
import { C as ConfigObserver } from './ConfigObserver-xpKlUycK.js';

const ThemeProvider = ({
  children,
  theme = stormLightTheme
}) => /*#__PURE__*/React__default.createElement(ConfigObserver, null, config => /*#__PURE__*/React__default.createElement(ThemeProvider$1, {
  theme: theme
}, children));

export { ThemeProvider as T };
//# sourceMappingURL=ThemeProvider-DG6Ur-A4.js.map
